import * as React from "react";

export function Lock(props) {
  return (
    <svg
    width={52}
    height={52}
    viewBox="0 0 52 52"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    >
    <g clipPath="url(#clip0_51_200)">
    <path
        d="M25.894 0C17.544 0 10.75 6.794 10.75 15.145v8.65c0 .098-.121.264-.216.295a47.66 47.66 0 00-2.093.745c-.726.28-1.274 1.084-1.274 1.872V46.58c0 .782.544 1.587 1.266 1.873a47.204 47.204 0 0017.462 3.334c6.005 0 11.88-1.122 17.463-3.334.721-.286 1.265-1.09 1.265-1.873V26.707c0-.788-.547-1.592-1.274-1.872a48.199 48.199 0 00-2.092-.745c-.095-.032-.217-.197-.217-.296v-8.65C41.04 6.795 34.245 0 25.894 0zM21.77 32.76a4.124 4.124 0 014.125-4.125 4.124 4.124 0 014.125 4.125c0 1.51-.852 2.775-2.063 3.492v6.82c0 1.14-.922 2.062-2.062 2.062a2.061 2.061 0 01-2.062-2.062v-6.82c-1.21-.717-2.063-1.982-2.063-3.492zm14.063-17.615v7.463a47.339 47.339 0 00-9.936-1.057c-3.333 0-6.675.356-9.94 1.056v-7.462c0-5.48 4.459-9.937 9.938-9.937 5.48 0 9.938 4.457 9.938 9.937z"
        fill="currentColor"
    />
    </g>
    <defs>
    <clipPath id="clip0_51_200">
        <path fill="currentColor" d="M0 0H51.7879V51.7879H0z" />
    </clipPath>
    </defs>
    </svg>
  );
}
